import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "62",
  height: "56",
  fill: "none",
  viewBox: "0 0 62 56"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FF9292",
      d: "M60.48 47.516 35.354 3.95c-1.931-3.351-6.775-3.351-8.71 0L1.517 47.516c-1.929 3.345.486 7.54 4.354 7.54h50.256c3.861 0 6.29-4.19 4.355-7.54m-29.482.837a3.352 3.352 0 1 1 0-6.703 3.352 3.352 0 0 1 0 6.703m4.005-24.967-1.34 13.405a1.675 1.675 0 0 1-1.668 1.509h-1.99a1.675 1.675 0 0 1-1.667-1.51l-1.34-13.404a1.673 1.673 0 0 1 1.663-1.842h4.675a1.674 1.674 0 0 1 1.667 1.842"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#B60000",
      d: "M33.337 21.543h-4.675a1.675 1.675 0 0 0-1.667 1.842l1.34 13.405a1.676 1.676 0 0 0 1.667 1.509h1.99a1.676 1.676 0 0 0 1.667-1.51L35 23.386a1.677 1.677 0 0 0-1.662-1.842M30.999 41.65a3.35 3.35 0 1 0 0 6.701 3.35 3.35 0 0 0 0-6.7"
    }, null, -1)
  ]))]))
}
export default { render: render }